<template>
    <div class="servico">
        <!-- Página: Climatização e Frio -->
        <section id="climatizacao" class="servico-section">
            <h2>Climatização e Frio</h2>
            <img src="@/assets/images/fjbac..jpg" alt="Sistema de Ar-Condicionado" class="servico-img" />
      <h2>Soluções para conforto térmico e conservação de produtos no clima quente de Benguela.</h2>
      <ul class="servico-lista">
        <li><button @click="abrirModal('modal1')">Instalação e manutenção de sistemas de ar condicionado e ventilação</button></li>
        <li><button @click="abrirModal('modal2')">Refrigeração comercial e industrial</button></li>
        <li><button @click="abrirModal('modal3')">Verificação de fugas e recarga de gás refrigerante</button></li>
      </ul>
    </section>

    <!-- Modal 1 -->
    <div v-if="modalAberto === 'modal1'" class="modal-overlay">
      <div class="modal-content">
        <h3>Instalação e manutenção de sistemas de ar condicionado e ventilação</h3>
        <p><strong>Descrição:</strong>Montagem de splits, VRF e sistemas de ventilação, com manutenção de
filtros e dutos</p>
        <p><strong>Benefício:</strong> Garante conforto e qualidade do ar em residências e empresas.</p>
        <p><strong>Exemplo:</strong> Instalação de split em escritório no Bairro da Luz.</p>
        <p><strong>Prazo:</strong> Simples (4-6 horas); Complexo (2-5 dias)</p>
        <p><strong>Pagamento:</strong> Simples (completo); Complexo (diagnóstico + parcelado)</p>
        <p><strong>Normas:</strong> ASHRAE 62.1, ISO 16890.</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>

    <!-- Modal 2 -->
    <div v-if="modalAberto === 'modal2'" class="modal-overlay">
      <div class="modal-content">
        <h3>Refrigeração comercial e industrial</h3>
        <p><strong>Descrição:</strong> Montagem e reparo de câmaras frias e freezers</p>
        <p><strong>Benefício:</strong> Conserva alimentos e medicamentos, apoiando o comércio local</p>
        <p><strong>Exemplo:</strong> Câmara fria para mercado no Lobito.</p>
        <p><strong>Prazo:</strong> Simples (1-2 dias); Complexo (1-2 semanas).</p>
        <p><strong>Pagamento:</strong> Simples (completo); Complexo (diagnóstico + parcelado).</p>
        <p><strong>Normas:</strong> AHRI, Protocolo de Montreal.</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>

    <!-- Modal 3 -->
    <div v-if="modalAberto === 'modal3'" class="modal-overlay">
      <div class="modal-content">
        <h3>Verificação de fugas e recarga de gás refrigerante</h3>
        <p><strong>Descrição:</strong> Descrição: Inspeção de vazamentos e recarga de gases (ex.: R410A)</p>
        <p><strong>Benefício:</strong> Benefício: Mantém eficiência e conformidade ambiental.</p>
        <p><strong>Exemplo:</strong> Exemplo: Recarga de gás em ar condicionado comercial.</p>
        <p><strong>Prazo:</strong> Prazo: Simples (2-4 horas); Complexo (1-2 dias)</p>
        <p><strong>Pagamento:</strong> Pagamento: Simples (completo); Complexo (diagnóstico + parcelado).</p>
        <p><strong>Normas:</strong> F-Gas Regulation, EPA..</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalAberto: null,
    };
  },
  methods: {
    abrirModal(modalId) {
      this.modalAberto = modalId;
    },
    fecharModal() {
      this.modalAberto = null;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.servico {
  padding: 40px;
  font-family: Arial, sans-serif;
  background-color: #f9f9f9;
}

.servico-section {
  margin-bottom: 60px;
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.servico-section h1,
h2 {
  text-align: center;
  color: #005580;
  margin-bottom: 20px;
}

.servico-section h1 {
  font-size: 28px;
  border-bottom: 2px solid #005580;
  padding-bottom: 10px;
}

.servico-section h2 {
  font-size: 20px;
  font-weight: normal;
}

.servico-img {
  display: block;
  margin: 0 auto 20px auto;
  width: 50%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
}

.servico-lista {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.servico-lista li button {
  background-color: #005580;
  color: white;
  border: none;
  padding: 12px 18px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
  text-align: center;
}

.servico-lista li button:hover {
  background-color: #0077a6;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
}

.modal-content h3 {
  margin-top: 0;
  color: #005580;
  margin-bottom: 20px;
  text-align: center;
}

.modal-content p {
  margin: 10px 0;
  line-height: 1.5;
  color: #333;
}

.fechar-btn {
  display: block;
  margin: 20px auto 0 auto;
  background-color: #cc0000;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.fechar-btn:hover {
  background-color: #e60000;
}

@keyframes fadeIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>